import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';

import { AuthHttpService } from '@app/core/services/http/auth/auth.service';

/**
 * Перед открытием админки загружает GET /b2b/me/context (партнер, сеть, точка пользователя),
 * чтобы страницы сразу получили их через getB2bAccessScope(). Ошибка загрузки вход не блокирует.
 */
export const b2bContextGuard: CanActivateFn = () =>
  inject(AuthHttpService)
    .loadB2bContext()
    .pipe(map(() => true));
